import { useContext } from 'react'

import { TimetableContext } from '~/components/dashboard/timetable/TimetableContext'

const useTimetableDate = () => {
  const {
    selectedDate,
    setSelectedDate,
    savedScrollPosition,
    saveScrollPosition,
    clearScrollPosition,
  } = useContext(TimetableContext)

  return {
    selectedDate,
    setSelectedDate,
    savedScrollPosition,
    saveScrollPosition,
    clearScrollPosition,
  }
}

export default useTimetableDate
